export default {
    SET_PERMISSIONS(state, array) {
        state.permissions = array;
    },
    ADD_PERMISSION(state, array) {
        state.permissions.unshift(array);
    }
}